import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import OfflineExperience from '../components/OfflineExperience'

const renderNothing = HOC => props => (props.isExperienceOffline ? <HOC {...props} /> : null)

const mapStateToProps = state => ({
    isExperienceOffline: state.getIn(['tour', 'isExperienceOffline']),
})

export default compose(
    connect(mapStateToProps),
    renderNothing
)(OfflineExperience)
